import React, { useState, useEffect } from "react";

const TableHeadCell = ({
  children,
  className,
  isSortable,
  onClick,
  orderBy,
  style = {},
}) => {
  const [sortOrder, setSortOrder] = useState(orderBy);

  useEffect(() => {
    setSortOrder(orderBy);
  }, [orderBy]);

  const additionalProps = {};

  const onSortClick = () => {
    const newOrder = ["desc", ""].includes(sortOrder) ? "asc" : "desc";
    setSortOrder(newOrder);
    onClick(newOrder);
  };

  if (isSortable) {
    additionalProps.onClick = onSortClick;
  }
  const sortClass = isSortable ? "sortable" : "";
  return (
    <div
      className={`d-flex table-head-cell ${className} ${sortClass} ${sortOrder}`}
      style={style}
      {...additionalProps}
    >
      {children}
    </div>
  );
};

export default TableHeadCell;
